import { render } from "./ReviewTemplates.vue?vue&type=template&id=6f3bef59&scoped=true"
import script from "./ReviewTemplates.vue?vue&type=script&lang=js"
export * from "./ReviewTemplates.vue?vue&type=script&lang=js"

import "./ReviewTemplates.vue?vue&type=style&index=0&id=6f3bef59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3bef59"]])

export default __exports__